import React from 'react';
import '@eleveo/foundation/lib/index.css';
import '@eleveo/foundation/lib/layout.css';
import '@eleveo/icons-react/lib/icon.css';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './index.scss';
import './translations/i18n';
import { RuntimeConfiguration } from './constants/integrationConstants';

declare global {
  interface Window {
    ENV: RuntimeConfiguration['env'];
  }
}

const container = document.getElementById('integrations-ui-root') as HTMLElement;
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App env={window.ENV} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// reportWebVitals();
